export const COUNTRIES_AMERICA = [
  'AI',
  'AG',
  'AR',
  'AW',
  'BS',
  'BB',
  'BO',
  'BQ',
  'BV',
  'BR',
  'CA',
  'KY',
  'CL',
  'CO',
  'CR',
  'CU',
  'CW',
  'BZ',
  'BM',
  'DM',
  'DO',
  'EC',
  'SV',
  'FK',
  'GF',
  'GL',
  'GD',
  'GP',
  'GT',
  'GY',
  'HT',
  'HN',
  'JM',
  'MQ',
  'MX',
  'MS',
  'NI',
  'PA',
  'PY',
  'PE',
  'PR',
  'BL',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'SX',
  'GS',
  'SR',
  'TT',
  'TC',
  'US',
  'UY',
  'VE',
  'VG',
  'VI'
];
